<template>
  <div>
    <template v-if="!orderid">
    <div class="steps" v-if="stepNum != 0">
      <div class="banner_steps">
        <div class="place_order_title">
          <svg class="icon icona_xiadan_banner" aria-hidden="true">
            <use xlink:href="#icona_xiadan_banner" />
          </svg>
          极速下单
        </div>
      </div>

      <div class="steps_main">
        <div class="list_text" v-if="stepNum != 3">
          <ul>
            <li>
              <span>超过3m³每方加收费用，不足1方按1方算，特殊区域价格另议</span>
            </li>
            <li>
              <span
                >报价仅适用层高3米及3米内，超过3米您需要接受师傅适当加价</span
              >
            </li>
            <li>
              <span>每一种商品基础费用*数量的累加</span>
            </li>
          </ul>
        </div>
        <div class="steps_box">
          <img
            :src="
              stepNum == 1 ? stepsOne : stepNum == 2 ? stepsTwo : stepsThree
            "
            alt
          />
          <div class="steps_text">
            <div :class="stepNum >= 1 ? 'checked_steps' : ''">
              填写服务
            </div>
            <div :class="stepNum >= 2 ? 'checked_steps' : ''">填写商品信息</div>
            <div :class="stepNum >= 3 ? 'checked_steps' : ''">发布成功</div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="finish!='finish'">
    <div class="steps speed" v-if="speedNum!=0">
      <div class="banner_steps">
        <div class="place_order_title">
          <svg class="icon icona_xiadan_banner" aria-hidden="true">
            <use xlink:href="#icona_xiadan_banner" />
          </svg>
          极速下单
        </div>
      </div>

      <div class="steps_main">
        <div class="steps_box">
          <img
            :src="
              speedNum == 1 ? stepsOne : speedNum == 2 ? stepsTwo : stepsThree
            "
            alt
          />
          <div class="steps_text">
            <div :class="speedNum >= 1 ? 'checked_steps' : ''">
              填写服务
            </div>
            <div :class="speedNum >= 2 ? 'checked_steps' : ''">填写商品信息</div>
            <div :class="speedNum >= 3 ? 'checked_steps' : ''">发布成功</div>
          </div>
        </div>
      </div>
    </div>
    </template>
    </template>
  </div>
</template>

<script>
import Bus from "./../../utils/bus.js";
export default {
  data() {
    return {
      stepsOne: require("../../assets/img/steps_1.png"),
      stepsTwo: require("../../assets/img/steps_2.png"),
      stepsThree: require("../../assets/img/steps_3.png"),
      stepNum: 0,
      speedNum:0,
      orderid:'',
      finish:''
    };
  },
  // props:{
  //   stepNum:{
  //     type:Number
  //   }
  // },
  created() {
    var _this = this;
    Bus.$on("val", (data) => {
      if(data.url=='speedOrder') _this.speedNum=data.step
      else _this.stepNum = data.step;
      
      console.log(_this.$route.query.orderid)
      _this.orderid=_this.$route.query.orderid
      _this.finish=data.finish
    });
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.steps {
  width: 100%;
  background: #ffffff;
  .banner_steps {
    background: url("../../assets/img/xiadan_banner.png") no-repeat;
    background-size: cover;
    height: 80px;
    color: #ffffff;
    font-size: 30px;
    padding: 24px 63px;
    .place_order_title {
      height: 30px;
      line-height: 30px;
    }
    .icona_xiadan_banner {
      width: 32px;
      height: 30px;
      margin-right: 19px;
    }
  }
  &.speed{
    .banner_steps {
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      .icona_xiadan_banner{
        margin-right: 0;
      }
    }
    .steps_main{
      padding: 33px 0;
    }
  }
  .steps_main {
    padding: 21px 0;
  }
  .list_text {
    padding: 0px 63px 0 63px;
    li {
      list-style: outside;
      font-size: 12px;
      color: #3455d3;
      height: 26px;
      line-height: 26px;
      margin-left: 25px;
      span {
        color: #2f3133;
      }
    }
  }
}
.steps_box {
  // padding: 0 0 21px 0;
  img {
    width: 100%;
    height: 58px;
  }
  .steps_text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 204px;
    margin-top: 12px;
    div {
      width: 126px;
      text-align: center;
    }
    .checked_steps {
      color: #3455d3;
    }
  }
}
.footer {
  margin-top: -15px;
}
</style>